module.exports = __webpack_public_path__ + "img/bottom.704e4fed.png";